module.exports = __webpack_public_path__ + "img/find-rect-icon.0bd32726.svg";